(() => {
  document.documentElement.classList.add('bn-sales-only-page');

  const initSection = (section) => {
    if (!section || section.dataset.benergyReady === 'true') return;
    section.dataset.benergyReady = 'true';

    const form = section.querySelector('[data-benergy-form]');
    const variantInput = section.querySelector('[data-variant-input]');
    const bundleOptions = [...section.querySelectorAll('[data-bundle-option]')];
    const price = section.querySelector('[data-selected-price]');
    const compare = section.querySelector('[data-selected-compare]');
    const stock = section.querySelector('[data-stock]');
    const addButton = section.querySelector('[data-add-button]');
    const buttonLabel = section.querySelector('[data-button-label]');
    const message = section.querySelector('[data-form-message]');
    const sticky = section.querySelector('[data-sticky-bar]');
    const stickyTitle = section.querySelector('[data-sticky-title]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat('ms-MY', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'MYR',
          minimumFractionDigits: 2
        }).format(Number(cents) / 100);
      } catch (error) {
        return `RM${(Number(cents) / 100).toFixed(2)}`;
      }
    };

    const updateSelectedVariant = (option) => {
      if (!option) return;
      const available = option.dataset.available === 'true';
      const optionPrice = Number(option.dataset.price || 0);
      const comparePrice = Number(option.dataset.comparePrice || 0);

      bundleOptions.forEach((item) => {
        item.closest('.bn-bundle')?.classList.toggle('is-selected', item === option);
      });
      if (variantInput) variantInput.value = option.value;
      if (price) price.textContent = option.dataset.priceFormatted || formatMoney(optionPrice);
      if (compare) {
        compare.hidden = !(comparePrice > optionPrice);
        compare.textContent = comparePrice > optionPrice ? formatMoney(comparePrice) : '';
      }
      if (stock) {
        stock.textContent = available ? 'Tersedia' : 'Habis stok';
        stock.classList.toggle('is-out', !available);
      }
      if (addButton) addButton.disabled = !available;
      if (buttonLabel) buttonLabel.textContent = available ? 'Pilih Bundle Saya' : 'Habis stok';
      if (stickyTitle) stickyTitle.textContent = option.dataset.title || '';
      if (stickyPrice) stickyPrice.textContent = option.dataset.priceFormatted || formatMoney(optionPrice);
      if (stickyAdd) stickyAdd.disabled = !available;
      if (stickyLabel) stickyLabel.textContent = available ? 'Pilih Bundle' : 'Habis stok';
    };

    bundleOptions.forEach((option) => {
      option.addEventListener('change', () => updateSelectedVariant(option));
    });

    const setLoading = (loading) => {
      if (addButton) addButton.disabled = loading;
      if (stickyAdd) stickyAdd.disabled = loading;
      if (buttonLabel && loading) buttonLabel.textContent = 'Menambah…';
      if (stickyLabel && loading) stickyLabel.textContent = 'Menambah…';
    };

    const showMessage = (text, isError = false) => {
      if (!message) return;
      message.textContent = text;
      message.classList.toggle('is-error', isError);
    };

    const addToCart = async () => {
      if (!form || !variantInput?.value) return;
      setLoading(true);
      showMessage('');

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Produk tidak dapat ditambah.');

        showMessage('Ditambah ke troli. Membuka troli…');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: result }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: result }));
        window.setTimeout(() => {
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        }, 450);
      } catch (error) {
        showMessage(error.message || 'Sesuatu berlaku. Sila cuba lagi.', true);
        const currentOption = bundleOptions.find((option) => option.checked);
        updateSelectedVariant(currentOption);
      } finally {
        setLoading(false);
      }
    };

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart();
    });
    stickyAdd?.addEventListener('click', addToCart);

    const galleryMain = section.querySelector('.bn-gallery__main');
    section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!galleryMain || !thumb.dataset.imageSrc) return;
        galleryMain.classList.add('is-changing');
        window.setTimeout(() => {
          galleryMain.src = thumb.dataset.imageSrc;
          galleryMain.srcset = '';
          galleryMain.alt = thumb.dataset.imageAlt || '';
          galleryMain.classList.remove('is-changing');
        }, 100);
        section.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      });
    });

    if (sticky && form && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.05 }
      );
      observer.observe(form);
    }

    updateSelectedVariant(bundleOptions.find((option) => option.checked));
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-benergy-section]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
